import styled from 'styled-components';
import { desktop_breakpoint } from 'pubweb-smokey/dist/components/GridSystem/_vars_widths.js';
import Colors from 'pubweb-smokey/dist/colors';

export const RetailerDealerInfoStyles = styled.div`
  hr {
    border: 1px solid ${Colors.accent.grey5.standard};
  }
  .separator-lower {
    position: relative;
    bottom: -2px;
  }
  .dealer-info-inside {
    height: 100%;
    padding: 24px 0;

    .stock-indicator {
      float: right;
      background-color: #fff;
      border-radius: 30px;
      color: ${Colors.primary.black.standard};
      padding: 4px 7px;

      .in-stock-dot {
        background-color: ${Colors.secondary.kiddiePool.standard};
        width: 6px;
        height: 6px;
        border-radius: 50%;
        margin: 4px 3px 4px 2px;
        float: left;
      }
    }
    .distance {
      font-family: 'Acumin Pro', sans-serif;
      font-weight: bold;
      font-size: 12px;
      line-height: 15px;
    }
    .dealer-name {
      a {
        color: ${Colors.primary.black.standard};
        text-decoration: none;
      }
    }
    .store-info {
      padding-top: 15px;

      span {
        padding-right: 10px;
        vertical-align: top;
      }
      .store-address {
        display: flex;
      }
      .address-line-two {
        padding-left: 27px;
      }
      .store-phone a {
        display: inline;
        color: ${Colors.primary.claytonBlue.standard};
        cursor: pointer;
      }
      .store-phone p {
        display: none;
      }
      .view-homes {
        padding-left: 4px;

        a {
          position: relative;
          top: 7px;
          color: ${Colors.primary.claytonBlue.standard};
          text-transform: uppercase;
          text-decoration: none;
          font-weight: 600;
          font-size: 14px;
          line-height: 14px;
          letter-spacing: 1px;
        }
      }
    }
  }
  @media only screen and (min-width: ${desktop_breakpoint}px) {
    padding-right: 25px;
    .dealer-info-inside .store-info .store-phone a {
      display: none;
    }
    .dealer-info-inside .store-info .store-phone p {
      display: inline;
      color: ${Colors.primary.claytonBlue.standard};
    }
    .separator-lower {
      position: relative;
      bottom: 1px;
    }
  }
`;
